import React, { useEffect } from 'react';
import { UserAuth } from 'store/auth';
import { useAppSelector } from 'store/hooks';
import { useGetStartPage } from 'hooks/useNavigation';

export default function BlankRouter() {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const startPageUrl = useGetStartPage();

    useEffect(() => {
        if (userAuth) {
            if ('' == (userAuth.topMenu?.customDomainApp ?? ''))
                window.location.href = startPageUrl + window.location.search + window.location.hash;
            else {
                window.location.href =
                    '/p/' + userAuth.topMenu?.customDomainApp + '/' + window.location.search + window.location.hash;
            }
        }
    }, []);

    return <div></div>;
}
